module KendoWidgets
{
	export class LinearGaugeOptions implements kendo.dataviz.ui.LinearGaugeOptions
	{
		name?: string;
		gaugeArea?: kendo.dataviz.ui.LinearGaugeGaugeArea;
		renderAs?: string;
		theme?: string;
		transitions?: boolean;

		slider?: boolean;
		width?: string | number;
		label?: string;
		css?: string;
		value?: number;
		color?: string;
		min?: number;
		max?: number;
		vertical?: boolean;
		minorUnit?: number;
		majorUnit?: number;
		enabled?: boolean;

		change?(e: LinearGaugeChangeEvent): void;
	}

	export class LinearGauge extends kendo.dataviz.ui.LinearGauge implements KendoWidget
	{
		private _slider: KendoWidgets.Slider;
		private _firstLoad: boolean;

		public controlType(): ControlTypeEnum { return ControlTypeEnum.LinearGauge; }

		constructor(element: Element, options?: KendoWidgets.LinearGaugeOptions)
		{
			if (options == null)
				options = new KendoWidgets.LinearGaugeOptions();

			if (options.slider == null) options.slider = true;
			if (options.value == null) options.value = 0;
			if (options.width == null) options.width = 190;
			if (options.color == null) options.color = KendoWidgets.ColorEnum.BlueVettore;
			if (options.min == null) options.min = 0;
			if (options.max == null) options.max = 100;
			if (options.vertical == null) options.vertical = true;
			if (options.enabled == null) options.enabled = true;

			(options as any).pointer = [{}];
			(options as any).pointer[0].value = options.value;
			(options as any).pointer[0].color = options.color;

			//#region Scale
			if ((options as any).scale == null)
				(options as any).scale = {};

			(options as any).scale.min = options.min;
			(options as any).scale.max = options.max;
			(options as any).scale.vertical = options.vertical;

			let realMaxValue = Math.abs((options.max - options.min) / 6);
			realMaxValue = (realMaxValue % 5 == 0) ? realMaxValue : realMaxValue + (5 - realMaxValue % 5);
			let realMinValue = realMaxValue / 10;

			(options as any).scale.minorUnit = (options.minorUnit != null) ? options.minorUnit : realMinValue;
			(options as any).scale.majorUnit = (options.majorUnit != null) ? options.majorUnit : realMaxValue;
			//#endregion

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			$(element).width(options.width);
			//#endregion

			super(element, options);
			$(this.element).wrap("<div id='" + element.id + "_linearGaugeContainer'  class='linearGaugeContainer'></div>");

			//#region Slider
			if (options.slider)
			{
				let inputSlider = $("<input></input>").appendTo(this.element.parent())[0];
				this._slider = <KendoWidgets.Slider>$(inputSlider).kendoSlider(
					{
						color: options.color,
						showButtons: false,
						min: options.min,
						max: options.max,
						largeStep: (options as any).scale.majorUnit,
						css: "margin-top: 5px;",
						enabled: options.enabled,
						change: (e) =>
						{
							this.value(e.value);

							if (options!.change != null)
							{
								let changeEvent = new LinearGaugeChangeEvent();
								changeEvent.value = e.value;
								options!.change(e);
							}
						}
					}).data("kendoSlider");

				this._slider.value(options.value);
				this._slider.element.parent().parent().css("margin-left", "7px");
				$(this.element).parent().css("margin-bottom", "25px");
			}
			//#endregion

			//#region Label
			let label = null;
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						height: 20,
						fontSize: 14,
						css: "margin-bottom: 20px;"
					});

				$(label).addClass("k-label-top");
				element.parentElement!.style.cssText += "display: flex; flex-direction: column;";
				element.parentElement!.insertBefore(label, element.parentElement!.firstChild);

				(element as HTMLElement).style.cssText += "width: 100%";
			}
			//#endregion

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).parentElement!.style.cssText += options.css;
			//#endregion
		}

		value(value?: number)
		{
			if (value != null)
			{
				(this as any).pointers[0].value(value);
				this._slider?.value(value);
			}

			return (this as any).pointers[0].value();
		}

		clear()
		{
			let options = this.getOptions();
			(this as any).pointers[0].value(options.value);
		}

		getOptions()
		{
			return (this.options as KendoWidgets.LinearGaugeOptions)!;
		}

		enabled(value?: boolean)
		{
			if (this._slider == null)
				return;

			if (value != null)
				this._slider.enable(value);

			return !(this._slider.element[0] as HTMLInputElement).disabled
		}

		//#region Append
		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().prependTo(element);
		}
		//#endregion
	}

	class LinearGaugeChangeEvent
	{
		value?: number;
	}

	LinearGauge.fn = LinearGauge.prototype;
	LinearGauge.fn.options = $.extend(true, {}, kendo.dataviz.ui.LinearGauge.fn.options);
	LinearGauge.fn.options.name = "LinearGauge";
	kendo.ui.plugin(LinearGauge);
}

interface JQuery
{
	kendoLinearGauge(options?: KendoWidgets.LinearGaugeOptions): JQuery;
}